import { Component, OnInit, Input } from '@angular/core';
import { NgStyle, NgClass } from '@angular/common';

@Component({
    selector: 'app-expander',
    templateUrl: './expander.component.html',
    styleUrls: ['./expander.component.scss'],
    imports: [NgStyle, NgClass]
})
export class ExpanderComponent implements OnInit {

  @Input()
  isExpanded = false;

  @Input()
  canExpand = true;

  @Input()
  type = 'primary'

  constructor() { }

  ngOnInit() {
  }

  toggle() {
    if (!this.canExpand) {
      return;
    }

    this.isExpanded = !this.isExpanded
  }

}
